import { NextParsedUrlQuery } from "next/dist/server/request-meta";
import { Variant } from "@/types/types.ts";
import type { UrlObject } from "url";

export function createSelectedSizeUrlObj(
  targetVariant: Variant,
  query: NextParsedUrlQuery,
): UrlObject {
  const queryParams = Object.entries(query).reduce((acc, [key, val]) => {
    return key === "path" || !val ? acc : { ...acc, [key]: val };
  }, {});

  return {
    pathname: targetVariant.pdpURL.path,
    query: { ...queryParams, size: targetVariant.pdpURL.query?.size },
  };
}
